import React from "react";
import { connect } from "react-redux";
import { getAccidentesList } from "../Planes/actions";
import Loading from "../Util/Loading";
import HeaderPlanMovilidad from "../Util/Header";
import AccordionSiniestros from "./accordionSiniestros";
import { push } from "connected-react-router";
import { paths } from "../../../config/routes";

class Accidentes extends React.Component {

  componentDidUpdate = (prevProps) => {
    if ( this.props.sucursalId !== "" && !this.props.listadoSiniestros ) {
      this.props.dispatch(getAccidentesList(this.props.companyId, this.props.sucursalId));
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  render() {
    return (
      <div id="accidentes">
        {this.props.isLoadingSiniestros && <Loading />}
        <HeaderPlanMovilidad />
        <section className="col-sm-12">
          {
            (this.props.sucursalId === "") ?
              <div className="row">
                <div className="col-md-12 text-center">
                  <h5>Selecciona un centro de trabajo para acceder a la opción de accidentes.</h5>
                </div>
              </div>
              :
              (this.props.ultimoEstadoProceso !== 0) ?
                <div className="position-relative overflow-hidden col-sm-12 text-center">
                  <div className="col-sm-12 text-center">
                    <span className="PM-section-title">Accidentes de Trayecto</span>
                  </div>
                  <div className="col-sm-12 text-center">
                    <h5>En esta sección puedes visualizar el historial de accidentes de trayecto de tu centro de trabajo. Para cada caso, te solicitamos completar la información requerida.</h5>
                  </div>
                  <div className="col-sm-12 text-center">
                    {
                      (this.props.listadoSiniestros) ?
                        <AccordionSiniestros
                          items={this.props.listadoSiniestros}
                        />
                        :
                        <h5>No hay registro de accidentes</h5>
                    }
                  </div>
                </div>
                :
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h5>No tiene generado ningún plan de movilidad</h5>
                  </div>
                </div>
          }
        </section>
        <div className="PM-footer">&nbsp;</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoadingSiniestros: state.planMovilidad.isLoadingSiniestros,
  listadoSiniestros: state.planMovilidad.listadoSiniestros,
  sucursalId: state.global.sucursalId,
  companyId: state.global.companyId,
  ultimoEstadoProceso: state.planMovilidad.ultimoEstadoProceso,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Accidentes);
